import { datadogRum } from '@datadog/browser-rum';
import { EBEnvs, getCurrentEnv } from '@eventbrite/feature-detection';
import { initializeRealUserMonitoring } from '@eventbrite/real-user-monitoring';
import { trackInitialPageView } from '@eventbrite/site-analytics';
import { useEffect } from 'react';
import { useMount } from 'react-use';
import { useEnvContext, useRouteContext } from '../../../../context/';

export const useAnalyticsAndMonitoring = () => {
    const envContext = useEnvContext();
    const { location } = useRouteContext();

    const env = envContext?.env;
    const request = envContext?.request;
    const sessionId = request?.session_id;
    const gaSettings = envContext?.gaSettings;
    const app_version = envContext?.app_version;
    const app_name = envContext?.app_name;
    const pathname = location?.pathname;
    const search = location?.search;

    useEffect(() => {
        trackInitialPageView(gaSettings, {
            dimensions: { sessionId },
            location: window.location.href,
        });
    }, [pathname, search, gaSettings, sessionId]);

    useMount(() => {
        if (env && getCurrentEnv({ env }) === EBEnvs.PROD) {
            initializeRealUserMonitoring({
                sampleRate: 10,
                version: app_version,
                service: app_name,
                env: EBEnvs.PROD,
            });

            datadogRum.onReady(() =>
                datadogRum.addRumGlobalContext(
                    'view.sub_app',
                    'category-browse',
                ),
            );
        }
    });
};
